<template>
  <div class="week-data">
    <canvas id="week-data"></canvas>
  </div>
</template>

<script>
  const F2 = require('@antv/f2/lib/index')
  export default {
    data () {
      return {
        data: [
          { x: '周一', y: 0 },
          { x: '周二', y: 0 },
          { x: '周三', y: 0 },
          { x: '周四', y: 0 },
          { x: '周五', y: 0 },
          { x: '周六', y: 0 },
          { x: '周七', y: 0 }
        ]
      }
    },
    methods: {
      InitData () {
        const chart = new F2.Chart({
          id: 'week-data',
          pixelRatio: window.devicePixelRatio
        })
        chart.source(this.data, {
          y: {
            alias: '饮水总量(L)',
            min: 0,
            minLimit: 0,
            formatter (e) {
              return Number(e).toFixed(2)
            }
          }
        })
        chart.interval().position('x*y')
        this.data.map(({ x, y }) => {
          chart.guide().text({
            position: [x, y],
            content: y,
            offsetY: -10
          })
        })
        chart.render()
      },
      WaterGetWeek () {
        this.$Get('Common.WaterGetWeek', {
          cup_id: this.$route.query.id
        }).then(({ data: { data } }) => {
          this.data = data.map(item => ({
            ...item,
            y: Number(item.y / 1000).toFixed(2) * 1
          }))
          this.InitData()
        })
      }
    },
    created () {
      this.WaterGetWeek()
    }
  }
</script>

<style lang="less" scoped>
  .week-data {
    .w(7.21rem);
    .h(5.16rem);
    .m(.5rem auto);
    canvas {
      .w();
      .h();
    }
  }
</style>
